import FetchData from '@shared/utils/fetchData/fetchData';

export const removeProductFromFavorites = async (id: string) => {
  return await FetchData.delete<{ message: string }>('favourites', {
    body: JSON.stringify({ id })
  });
};
